module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/hotsale-mobile.a5e977e3.png";